import { render, staticRenderFns } from "./WhatsNewSubSection.vue?vue&type=template&id=16469c46&scoped=true"
import script from "./WhatsNewSubSection.vue?vue&type=script&lang=js"
export * from "./WhatsNewSubSection.vue?vue&type=script&lang=js"
import style0 from "./WhatsNewSubSection.vue?vue&type=style&index=0&id=16469c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16469c46",
  null
  
)

export default component.exports